/* BRAVA — mobile sticky buy bar (2026-09 UX pass).
   Mirrors the inline add-to-cart button (label, disabled state) and the live price,
   and forwards the tap to it, so the theme's own AJAX cart logic runs unchanged.
   The theme may re-render the product section after load, so this script re-binds
   whenever a new bar / inline button appears instead of trusting the first one. */
(function(){
  var bar = null, inline = null, mo = null;

  function priceText(){
    var section = bar.closest('.shopify-section') || document;
    var box = section.querySelector('#product-price');
    if (!box) return '';
    var onSale = box.classList.contains('price--on-sale');
    var p = box.querySelector(onSale ? '[data-sale-price]' : '.price__regular [data-regular-price]');
    return p ? p.textContent.trim() : '';
  }
  function sync(){
    if (!bar || !inline) return;
    var btn = bar.querySelector('[data-brava-sticky-btn]');
    var price = bar.querySelector('[data-brava-sticky-price]');
    if (btn) { btn.textContent = inline.textContent.trim(); btn.disabled = !!inline.disabled; }
    var t = priceText();
    if (price && t) price.textContent = t;
  }
  function update(){
    if (!bar || !inline || !document.body.contains(bar)) return;
    var r = inline.getBoundingClientRect();
    var out = r.bottom < 0 || r.top > window.innerHeight;
    var show = out && window.innerWidth < 980;
    bar.hidden = !show;
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.documentElement.classList.toggle('has-sticky-buy', show);
  }
  function bind(){
    if (mo) mo.disconnect();
    var btn = bar.querySelector('[data-brava-sticky-btn]');
    if (btn) btn.onclick = function(){ inline.click(); };
    mo = new MutationObserver(sync);
    mo.observe(inline, { attributes: true, childList: true, subtree: true, characterData: true });
    var section = bar.closest('.shopify-section') || document;
    var box = section.querySelector('#product-price');
    if (box) mo.observe(box, { attributes: true, childList: true, subtree: true, characterData: true });
    sync(); update();
  }
  function find(){
    var b = document.querySelector('[data-brava-sticky-buy]');
    if (!b) return;
    var section = b.closest('.shopify-section') || document;
    var i = section.querySelector('form.js-prod-form-submit button[type="submit"]');
    if (!i) return;
    if (b === bar && i === inline) { update(); return; }
    bar = b; inline = i; bind();
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  document.addEventListener('cart:drawer:open', function(){ if (bar) { bar.hidden = true; } });
  find();
  setInterval(find, 500);
})();
